import { render } from "./DictItemList.vue?vue&type=template&id=a8f66796"
import script from "./DictItemList.vue?vue&type=script&lang=js"
export * from "./DictItemList.vue?vue&type=script&lang=js"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__